import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faServer } from '@fortawesome/free-solid-svg-icons';
import ICloudIntegration from './ICloudIntegration';
import { useAuth } from '../contexts/AuthContext';
import { iCloudService } from '../services/iCloudService';

import GoogleCalendarIntegration from './GoogleCalendarIntegration';
import {useEnvironment} from "@/contexts/EnvironmentContext.jsx";

const CalendarIntegrations = () => {
    const { user } = useAuth();
    const {
        environment,        // 'development' or 'production'
        isDevelopment,      // boolean flag
        isProduction,       // boolean flag
        calendarApiEndpoints,       // object with API endpoints
        changeEnvironment   // function to change environment
    } = useEnvironment();
    const [userIcloudCredentials, setiCloudCredentials] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchUserCredentials = async () => {
            if (!user?.id) {
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError('');

                const userIcloudCredentials = await iCloudService.getUserCredentials(user.id, calendarApiEndpoints.icloud);

                setiCloudCredentials(userIcloudCredentials);
            } catch (err) {
                console.error('Error fetching user credentials:', err);
                setError('Failed to load user credentials. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchUserCredentials();
    }, [user?.id]);

    return (
        <Card className="mb-4 shadow-sm">
            <Card.Header as="h5">
                <FontAwesomeIcon icon={faServer} className="me-2" />
                Calendar Integrations
            </Card.Header>
            <Card.Body>
                <div className="d-flex flex-column gap-4">
                    <ICloudIntegration userIcloudCredentials={userIcloudCredentials} />
                    <GoogleCalendarIntegration />
                </div>
            </Card.Body>
        </Card>
    );
};

export default CalendarIntegrations;